import type { ImageWidget } from "~/types/widgets"
import { Picture, Source } from "~/components/ui/Picture"

export interface Props {
    /**
     * @title Imagem
     */
    image: {
        mobile: ImageWidget
        desktop?: ImageWidget
        /**
         * @title Texto alternativo
         */
        altText: string
    }
    /**
     * @title Pins
     */
    pins: Pin[]
    /**
     * @title Texto
     */
    text?: string
    /**
     * @title Título
     */
    title?: string
    link?: {
        /**
         * @title Texto do botão
         */
        text: string
        /**
         * @title Link
         */
        href: string
    }
}

/**
 * @titleBy link
 */
export interface Pin {
    mobile: {
        x: number
        y: number
    }
    desktop?: {
        x: number
        y: number
    }
    link: string
    /**
     * @title Texto do botão
     */
    label: string
}

const DEFAULT_PROPS: Props = {
    link: {
        href: '#',
        text: 'Ver agora',
    },
    pins: [],
    image: {
        mobile:
            'https://decoims.com/miess-01/3f39c0ff-4793-4add-a77b-949b51f115c9/cac2dc1c-48ac-4274-ad42-4016b0bbe947.jpg',
        altText: 'Fashion',
    },
}

export default function ShoppableBanner(props: Props) {
    const { link, text, title, image, pins } = { ...DEFAULT_PROPS, ...props }

    return (
        <div className='container'>
            <div className='card lg:card-side rounded grid grid-cols-1 lg:grid-cols-[70%_30%]'>
                <figure className='relative'>
                    <Picture>
                        <Source
                            media='(max-width: 767px)'
                            src={image?.mobile}
                            width={150}
                            height={150}
                        />
                        <Source
                            media='(min-width: 768px)'
                            src={image?.desktop ? image?.desktop : image?.mobile}
                            width={384}
                            height={227}
                        />
                        <img
                            className='w-full object-cover'
                            sizes='(max-width: 640px) 100vw, 30vw'
                            src={image?.mobile}
                            alt={image?.altText}
                            decoding='async'
                            loading='lazy'
                        />
                    </Picture>
                    {pins.map(({ mobile, desktop, link, label }) => (
                        <>
                            <a
                                href={link}
                                className='absolute w-min btn btn-accent rounded-full hover:rounded text-accent no-animation md:scale-[30%] hover:text-accent-content hover:scale-125 sm:hidden'
                                style={{
                                    left: `${mobile.x}%`,
                                    top: `${mobile.y}%`,
                                }}
                            >
                                <span>{label}</span>
                            </a>
                            <a
                                href={link}
                                className='absolute w-min btn btn-accent rounded-full hover:rounded text-accent no-animation md:scale-[30%] hover:text-accent-content hover:scale-125 hidden sm:inline-flex'
                                style={{
                                    left: `${desktop?.x ?? mobile.x}%`,
                                    top: `${desktop?.y ?? mobile.y}%`,
                                }}
                            >
                                <span>{label}</span>
                            </a>
                        </>
                    ))}
                </figure>
                <div className='card-body'>
                    <h2 className='card-title'>{title}</h2>
                    <p>{text}</p>
                    <div className='card-actions justify-end'>
                        <a className='btn btn-primary' href={link?.href}>
                            {link?.text}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
export { default as LoadingFallback } from "~/components/LoadingFallback"
